import { useAuth, UserRole } from "@/features/auth";
import { useTanstackDevToolsInProduction } from "@/shared/hooks/use-tanstack-devtools-production.ts";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { lazy, Suspense } from "react";

const ReactQueryDevtoolsProduction = lazy(() =>
    import("@tanstack/react-query-devtools/build/modern/production.js").then((d) => ({
        default: d.ReactQueryDevtools,
    }))
);

/**
 * Renders either the normal dev-mode devtools in non-production builds, or de production-mode devtools when enabled
 * through the beheer page.
 *
 * @constructor
 */
export function TanstackQueryDevtools() {
    const { hasRole } = useAuth();
    const [devToolsEnabled] = useTanstackDevToolsInProduction();

    return (
        <>
            {hasRole(UserRole.ADMIN, true) && <ReactQueryDevtools />}
            {devToolsEnabled && (
                <Suspense fallback={null}>
                    <ReactQueryDevtoolsProduction />
                </Suspense>
            )}
        </>
    );
}
